import { render, staticRenderFns } from "./DetalleCursoActual.vue?vue&type=template&id=0f1b7754&"
import script from "./DetalleCursoActual.vue?vue&type=script&lang=js&"
export * from "./DetalleCursoActual.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCursoActual.vue?vue&type=style&index=0&id=0f1b7754&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports